/**
 * Minimal shape needed to evaluate the takeover gate. Decoupled from the full
 * generated `Dispensaries` type so this helper works for typed (.tsx) and
 * untyped (.jsx) callers alike.
 */
type DispensaryWithTakeoverSetting = {
  storeSettings?: {
    enableOrderTypeTakeoverModal?: boolean | null;
  } | null;
} | null;

/**
 * Evaluates the admin-controlled `enableOrderTypeTakeoverModal` store setting
 * (Settings > Menu) for a dispensary. Defaults to `false` when unset.
 *
 * This is only the store-setting half of the gate. The full takeover gate —
 * this setting AND the rollout flag — lives in `useIsOrderTypeTakeoverEnabled`,
 * which is the entry point call sites should use. This helper stays pure (no
 * React) so it can be unit-tested and composed by that hook.
 *
 * Because the setting arrives on the dispensary GraphQL payload (not client-side
 * context-flag evaluation), it isn't subject to the SSR-bootstrap context race
 * that affected the original consumer flag (ECOMM-11202).
 */
export function isOrderTypeTakeoverEnabled(dispensary: DispensaryWithTakeoverSetting | undefined): boolean {
  return dispensary?.storeSettings?.enableOrderTypeTakeoverModal ?? false;
}
